import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Wedding Planning',
        content: 'Professional wedding and event planning to make your big day memorable.',
        paragraphs: [
            'We work closely with you to bring your vision to life, curating everything from flowers to music, while making sure every aspect is handled with care and attention to detail.',
            'Our wedding planners ensure that your big day is everything you’ve dreamed of, coordinating each part of the event to create an unforgettable atmosphere.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Personalized Planning',
            'Venue Scouting & Booking',
            'Vendor Coordination',
            'Decor & Design Consultation',
            'Day-of Coordination'
        ],
        procedure: [
            'Initial Consultation & Vision Setting',
            'Vendor Selection & Contracts',
            'Detailed Timeline Creation',
            'Decor & Design Execution',
            'Day-of Wedding Coordination'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What does a wedding planner do?',
                content: 'A wedding planner helps you manage all aspects of your wedding, including budget management, vendor coordination, design, and day-of coordination to ensure everything runs smoothly.'
            },
            {
                id: 2,
                heading: 'How early should I book a wedding planner?',
                content: 'It\'s recommended to book a wedding planner as soon as you set your wedding date, typically 12 to 18 months before the big day, to ensure availability and ample planning time.'
            },
            {
                id: 3,
                heading: 'Can you help with destination weddings?',
                content: 'Yes, we specialize in both local and destination weddings. We handle all the details to make your dream destination wedding come true.'
            },
            {
                id: 4,
                heading: 'What if I only need day-of coordination?',
                content: 'We offer flexible packages, including day-of coordination, to help you with just the final details and execution on your wedding day.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Venue Selection',
        content: 'Helping you choose the perfect venue that matches your vision and style.',
        paragraphs: [
            'Our team specializes in helping you find the ideal venue for your event, whether you’re planning a wedding, corporate gathering, or private celebration. We work with a variety of venues to find one that fits your theme, guest list, and budget.',
            'We guide you through every step of the venue selection process, from venue tours to final bookings, ensuring the venue aligns perfectly with your vision for the event.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Comprehensive Venue Options',
            'Personalized Venue Recommendations',
            'Budget-Friendly Choices',
            'Access to Exclusive Venues',
            'Site Tours and Assessments'
        ],
        procedure: [
            'Initial Consultation & Event Vision Discussion',
            'Venue Research & Shortlisting',
            'Venue Tours & Final Selection',
            'Venue Booking & Contract Negotiation',
            'Final Venue Setup & Coordination'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How do I choose the right venue?',
                content: 'We help you find the perfect venue by understanding your vision, guest count, and event needs. We provide personalized recommendations based on your preferences.'
            },
            {
                id: 2,
                heading: 'Can you help with booking the venue?',
                content: 'Yes, we manage the entire venue booking process, from securing your desired location to finalizing contracts and ensuring everything is ready for your event.'
            },
            {
                id: 3,
                heading: 'Do you provide recommendations for outdoor venues?',
                content: 'Yes, we have access to a variety of beautiful outdoor venues and can recommend the best ones based on your event type, guest count, and budget.'
            },
            {
                id: 4,
                heading: 'What if the venue doesn’t have the necessary amenities?',
                content: 'We ensure that the venue meets all your requirements, and if necessary, we can recommend additional services such as rentals, catering, and more to ensure everything is covered.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Floral Design',
        content: 'Beautiful floral arrangements tailored to complement your wedding theme.',
        paragraphs: [
            'Our expert florists create stunning floral arrangements that perfectly match your wedding theme. From elegant bouquets to breathtaking centerpieces, we ensure your flowers are the perfect complement to your big day.',
            'We offer a wide range of floral designs, including fresh, seasonal flowers, custom color schemes, and unique floral installations that will leave a lasting impression on your guests.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Custom Floral Arrangements',
            'Seasonal & Fresh Flowers',
            'Personalized Color Schemes',
            'Breathtaking Floral Installations',
            'Bridal Bouquets & Boutonnieres'
        ],
        procedure: [
            'Initial Consultation & Style Discussion',
            'Floral Design Proposal & Approval',
            'Flower Selection & Sourcing',
            'Floral Arrangement Creation & Setup',
            'Event Day Delivery & Floral Installation'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How do I choose the right flowers for my wedding?',
                content: 'We help you choose the perfect flowers based on your wedding theme, color scheme, and budget. We work closely with you to select flowers that reflect your personal style and vision.'
            },
            {
                id: 2,
                heading: 'Can you create custom floral designs?',
                content: 'Yes, we specialize in creating custom floral arrangements tailored to your specific preferences. Whether you want elegant and simple or bold and extravagant, we bring your floral vision to life.'
            },
            {
                id: 3,
                heading: 'Do you provide floral delivery and setup?',
                content: 'Yes, we offer full floral delivery and setup services to ensure that your arrangements are perfectly placed on the day of your event.'
            },
            {
                id: 4,
                heading: 'Can you help with wedding flowers for destination events?',
                content: 'Absolutely! We have experience working with destination weddings and can coordinate floral delivery and setup wherever your wedding is taking place.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Food Catering',
        content: 'Delectable menu options to suit all tastes, ensuring a delightful experience.',
        paragraphs: [
            'Our food catering services provide a wide range of delectable menu options, carefully crafted to suit every taste and preference. From gourmet appetizers to exquisite main courses and decadent desserts, we ensure that every dish is prepared with the finest ingredients and utmost care.',
            'Whether you are hosting an intimate gathering or a grand celebration, our team of experienced chefs will create a memorable dining experience that your guests will rave about.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Customized Menu Creation',
            'Gourmet & Seasonal Ingredients',
            'Dietary Accommodation Options',
            'Impeccable Food Presentation',
            'Experienced Culinary Team'
        ],
        procedure: [
            'Initial Menu Consultation & Customization',
            'Menu Tasting & Approval',
            'Food Preparation & Event Day Setup',
            'Seamless Service & Food Presentation',
            'Post-Event Feedback & Clean-Up'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can I customize my menu?',
                content: 'Absolutely! We work closely with you to create a customized menu that fits your event theme, dietary requirements, and personal preferences.'
            },
            {
                id: 2,
                heading: 'Do you offer options for special dietary needs?',
                content: 'Yes, we offer a variety of options including vegetarian, vegan, gluten-free, and more. Just let us know your specific dietary needs, and we will tailor the menu accordingly.'
            },
            {
                id: 3,
                heading: 'How do I know the food will taste good?',
                content: 'We offer tasting sessions prior to your event so you can sample the dishes and make any adjustments before the big day. Our chefs ensure that everything is prepared to perfection.'
            },
            {
                id: 4,
                heading: 'Do you provide staff for food service?',
                content: 'Yes, we provide a team of professional staff to serve the food, ensuring everything runs smoothly and your guests are well taken care of during the event.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Photo Coverage',
        content: 'Capturing timeless moments with professional photography services.',
        paragraphs: [
            'Our professional photography services are designed to capture the most precious moments of your special day. From candid shots to beautifully staged portraits, our photographers ensure that every emotion, every detail, and every cherished memory is preserved in high-quality images.',
            'We understand the importance of your event and work discreetly yet efficiently to ensure you get the perfect shots without interrupting the flow of the celebration. Our team is experienced in weddings, parties, and all kinds of special events.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'High-Quality Image Capturing',
            'Experienced & Professional Photographers',
            'Candid & Portrait Photography',
            'Customized Photo Packages',
            'Timely Delivery of Photos'
        ],
        procedure: [
            'Initial Consultation to Discuss Preferences',
            'Event Day Photography Coverage',
            'Post-Event Photo Editing & Retouching',
            'Preview & Review of Photos',
            'Delivery of Final Photos in Various Formats'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of events do you cover?',
                content: 'We specialize in covering weddings, engagements, parties, corporate events, and any other special occasion. Our photographers are skilled in capturing all types of events.'
            },
            {
                id: 2,
                heading: 'How many photos will I receive?',
                content: 'The number of photos depends on the package you select and the duration of the event. However, we ensure a comprehensive collection of high-quality images to tell the story of your event.'
            },
            {
                id: 3,
                heading: 'Do you offer photo albums?',
                content: 'Yes, we offer custom photo albums as part of our packages. You can choose from a variety of designs and layouts to preserve your memories in a beautiful, tangible format.'
            },
            {
                id: 4,
                heading: 'How long after the event will I receive my photos?',
                content: 'We typically deliver your edited photos within 2-4 weeks, depending on the scope of the event and the number of photos to be processed.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Live Music',
        content: 'Creating the perfect ambiance with live bands, DJs, and entertainment options.',
        paragraphs: [
            'Our live music services are designed to elevate the atmosphere of your event, whether it’s a wedding, party, or corporate gathering. From live bands playing your favorite tunes to professional DJs setting the perfect vibe, we ensure your event is filled with energy and unforgettable moments.',
            'We work with a variety of musicians and entertainers to match the mood and theme of your event, creating a custom playlist or music program that resonates with your guests.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Live Bands & DJs',
            'Custom Playlists and Setlists',
            'Variety of Music Genres',
            'Professional Sound & Lighting',
            'Flexible Entertainment Packages'
        ],
        procedure: [
            'Initial Consultation & Music Preference Discussion',
            'Band/DJ Selection Based on Your Preferences',
            'Event Day Setup and Sound Check',
            'Live Music Performance Throughout the Event',
            'Post-Event Feedback and Review'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Do you offer both bands and DJs?',
                content: 'Yes, we offer both live bands and DJs, depending on your preference and event requirements. We can tailor the entertainment to your specific style and audience.'
            },
            {
                id: 2,
                heading: 'Can I customize the playlist?',
                content: 'Absolutely! We will work with you to create a playlist that fits your event. Whether you prefer a mix of genres or specific songs, we’ll ensure the music aligns with your vision.'
            },
            {
                id: 3,
                heading: 'Do you provide sound and lighting equipment?',
                content: 'Yes, we provide all necessary sound and lighting equipment to ensure the performance is top-notch. Our technicians handle setup and troubleshooting to ensure everything runs smoothly.'
            },
            {
                id: 4,
                heading: 'Can you accommodate last-minute music requests?',
                content: 'We can accommodate reasonable last-minute requests during the event. However, we recommend finalizing the setlist and music preferences ahead of time to ensure a seamless performance.'
            }
        ]
    }
];

export default services;